import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { MdKeyboardBackspace } from 'react-icons/md';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import EditProductForm from '../../components/EditProductForm';
import Snackbar from '../../util/SnackBar';

export default function EditProductByStyleCode() {
  const [searchCode, setSearchCode] = useState('');
  const [activeStyleCode, setActiveStyleCode] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSearch = () => {
    const code = searchCode.trim();
    if (!code) {
      Snackbar.warning('Please enter a style code');
      return;
    }
    setSubmitting(true);
    setActiveStyleCode(code);
    setSubmitting(false);
  };

  const handleSearchSubmit = e => {
    e.preventDefault();
    handleSearch();
  };

  const resetSearch = () => {
    setActiveStyleCode(null);
    setSearchCode('');
  };

  return (
    <Grid
      container
      style={{ alignContent: 'flex-start', padding: '20px 5px 10px' }}
    >
      <Grid container justifyContent="center">
        <Typography
          style={{
            fontFamily: 'Montserrat',
            fontSize: 24,
            lineHeight: '28px',
            letterSpacing: '0.1em',
            marginBottom: 25,
          }}
        >
          EDIT PRODUCT BY STYLE CODE
        </Typography>
      </Grid>

      {activeStyleCode && (
        <Grid
          container
          alignItems="center"
          style={{ margin: '12px 0px 24px', cursor: 'pointer' }}
          onClick={resetSearch}
        >
          <MdKeyboardBackspace />
          <Typography style={{ marginLeft: 8, position: 'relative', bottom: 2 }}>
            Back to search
          </Typography>
        </Grid>
      )}

      {!activeStyleCode && (
        <Grid container justifyContent="center" style={{ marginTop: 20 }}>
          <form onSubmit={handleSearchSubmit} style={{ width: 420 }}>
            <TextInput
              field="Style Code"
              value={searchCode}
              onChange={e => setSearchCode(e.target.value)}
              height={43}
              width={420}
              placeholder="Enter style code and press Enter"
            />
            <Grid container style={{ marginTop: 20 }}>
              <Button
                text="Search"
                color="#000"
                textColor="#fff"
                width={420}
                height={40}
                type="submit"
                loading={submitting}
                onClick={handleSearch}
              />
            </Grid>
          </form>
        </Grid>
      )}

      {activeStyleCode && <EditProductForm styleCode={activeStyleCode} />}
    </Grid>
  );
}
